var map = {
	"./fr": 198,
	"./fr-ca": 196,
	"./fr-ca.js": 196,
	"./fr-ch": 197,
	"./fr-ch.js": 197,
	"./fr.js": 198
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 495;



//////////////////
// WEBPACK FOOTER
// ./~/moment/locale fr
// module id = 495
// module chunks = 0